var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar',{attrs:{"titel":"Details","actions":_vm.actions,"showBackBtn":""}}),_c('section',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row')],1)],1),(_vm.checkIfSupport)?_c('section',[_c('support-tools',{attrs:{"sources":_vm.code}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }